import React, { useEffect, useRef, useState } from "react";
import "./Map.less";

interface IMarkerMap {
  zoomLevel?: number;
  latitudeVal?: any;
  longitudeVal?: any;
  showPinAddress?: any;
  gestureHandling?: boolean;
  markerDraggable?: boolean;
}

const marker_icon = "https://maps.google.com/mapfiles/marker.png";

type GoogleMap = google.maps.Map;
type GoogleMarker = google.maps.Marker;

/**
 * Renders a single marker map component for showing a marker on a map use in 
 * VR training location.
 *
 * @param {IMarkerMap} props - The props for the component.
 * @param {number} props.latitudeVal - The latitude value for the marker.
 * @param {number} props.longitudeVal - The longitude value for the marker.
 * @param {number} [props.zoomLevel=2] - The zoom level for the map.
 * @param {boolean} [props.gestureHandling] - Whether to handle gestures on the map.
 * @param {boolean} [props.markerDraggable=true] - Whether the marker is draggable.
 * @return {JSX.Element} The rendered single marker map component.
 */
const SingleMarkerMap: React.FC<IMarkerMap> = ({
  latitudeVal,
  longitudeVal,
  zoomLevel = 2,
  gestureHandling,
  markerDraggable = true,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const geocoder: any = new google.maps.Geocoder();

  // let marker: GoogleMarker;
  const [marker, setMarker] = useState<GoogleMarker>();
  const [mapMarker, setMapMarker] = useState<GoogleMap>();
  const [markerAdd, setMarkerAdd] = useState<any>();

  const defaultLatitude = 39.8097343;
  const defaultLongitude = -98.5556199;

  // Default Map
  const initMap = (): void => {
    if (!mapMarker) {
      loadMap();
    } else {
      if (!isNaN(latitudeVal) && !isNaN(longitudeVal)) {
        const homeLocation: any = new google.maps.LatLng(
          latitudeVal,
          longitudeVal
        );
        addMarker(homeLocation, mapMarker);
      }

      // google.maps.event.addListener(mapMarker, "click", (event: any) => {
      //   addMarker(event.latLng, mapMarker);
      // });
    }
  };

  const loadMap = (): void => {
    const mapOptions = {
      zoom: zoomLevel,
      center: new google.maps.LatLng(defaultLatitude, defaultLongitude),
    };

    const map = new google.maps.Map(ref.current as HTMLElement, mapOptions);
    setMapMarker(map);
    if (gestureHandling) {
      map.setOptions({ gestureHandling: "none", keyboardShortcuts: false });
    }
  };

  // Add the marker at the clicked location
  const addMarker = (
    location: google.maps.LatLngLiteral,
    map: google.maps.Map
  ) => {
    if (!marker) {
      const newMarker = new google.maps.Marker({
        position: location,
        map: map,
        draggable: markerDraggable,
        title: markerAdd,
        icon: marker_icon,
      });
      setMarker(newMarker);
    } else {
      marker.setPosition(location);
    }
    map && map.setCenter(location);
    map && map.setZoom(15);
    marker && geocodePosition(marker?.getPosition());

    // marker &&
    //   google.maps.event.addListener(marker, "dragend", () => {
    //     geocodePosition(marker?.getPosition());
    //   });
  }

  const geocodePosition = (pos: any) => {
    geocoder.geocode(
      {
        latLng: pos,
      },
      (responses: any) => {
        if (responses && responses.length > 0) {
          setMarkerAdd(responses[0].formatted_address);
        } else {
          // alert("Cannot determine address at this location.");
        }
      }
    );
  }

  // Initialize Map
  useEffect(() => {
    initMap();
  }, [mapMarker, latitudeVal, longitudeVal]);

  return (
    <>
      <div className="map-container">
        <div
          ref={ref}
          className="map-container__map"
          id="map-container__map"
        ></div>
      </div>
    </>
  );
};

export default SingleMarkerMap;
